export const VolumeOffIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.71659 3.54935C6.88983 3.63261 7 3.8078 7 4V12C7 12.1922 6.88983 12.3674 6.71659 12.4507C6.54336 12.5339 6.33774 12.5105 6.18765 12.3904L3.82461 10.5H1.5C1.22386 10.5 1 10.2761 1 10V6C1 5.72386 1.22386 5.5 1.5 5.5H3.82461L6.18765 3.60957C6.33774 3.4895 6.54336 3.46609 6.71659 3.54935Z"
      fill="#2C2543"
    />
    <path
      d="M13.8536 5.64645C14.0488 5.84171 14.0488 6.15829 13.8536 6.35355L12.2071 8L13.8536 9.64645C14.0488 9.84171 14.0488 10.1583 13.8536 10.3536C13.6583 10.5488 13.3417 10.5488 13.1464 10.3536L11.5 8.70711L9.85355 10.3536C9.65829 10.5488 9.34171 10.5488 9.14645 10.3536C8.95118 10.1583 8.95118 9.84171 9.14645 9.64645L10.7929 8L9.14645 6.35355C8.95118 6.15829 8.95118 5.84171 9.14645 5.64645C9.34171 5.45118 9.65829 5.45118 9.85355 5.64645L11.5 7.29289L13.1464 5.64645C13.3417 5.45118 13.6583 5.45118 13.8536 5.64645Z"
      fill="#2C2543"
    />
  </svg>
);
